
export const dashboardOperator = {
  namespaced: true,
  state: {
    processSearch: null,
    buildingSearch: null
  },
  mutations: {
    storeOperatorProcessSearch(state, search) {
      state.processSearch = search;      
    },
    storeBuildingSearch(state, search) {
      state.buildingSearch = search;     
    }
  }
}
